import { createSlice } from "@reduxjs/toolkit";
import { fetchDraftProfessorPlayers, fetchDraftProfessorPageContent } from "./draftProfessorActions";

const initialState = {
  players: [],
  loading: false,
  error: null,
  pageContent: null,
};

const draftProfessorSlice = createSlice({
  name: "draftProfessor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDraftProfessorPlayers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDraftProfessorPlayers.fulfilled, (state, action) => {
        state.loading = false;
        state.players = Array.isArray(action.payload)
          ? action.payload
          : action.payload.results ?? [];
      })
      .addCase(fetchDraftProfessorPlayers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchDraftProfessorPageContent.fulfilled, (state, action) => {
        state.pageContent = action.payload;
      });
  },
});

export const selectDraftProfessor = (state) => state.draftProfessor;
export default draftProfessorSlice.reducer;
